/** Direct API writes participate even when the caller does not use React Query mutations. */
export function createWriteActivity(now: () => number = () => Date.now()) {
  let pending = 0;
  let settledAt = -Infinity;
  const listeners = new Set<() => void>();
  const notify = () => { for (const listener of listeners) listener(); };
  return {
    begin() {
      pending += 1;
      notify();
      let finished = false;
      return () => {
        if (finished) return;
        finished = true;
        pending -= 1;
        if (pending === 0) settledAt = now();
        notify();
      };
    },
    pending: () => pending,
    // Let the caller apply its canonical result/rollback before a background GET can start.
    canRefresh: () => pending === 0 && now() - settledAt >= 1_000,
    subscribe(listener: () => void) { listeners.add(listener); return () => { listeners.delete(listener); }; },
  };
}
export type WriteActivity = ReturnType<typeof createWriteActivity>;
export const writeActivity = createWriteActivity();
